import { getUserGuidePath } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import { GUIDE_PATH } from '../../../constants/guide';
import ExternalLinkButton from './ExternalLinkButton';

/**
 * 역할 가이드 링크 버튼 컴포넌트
 * @description
 * - 현재 리전에 맞는 콘솔 역할 가이드 문서 URL을 생성합니다.
 * - 생성된 URL로 연결되는 외부 링크 버튼을 렌더링합니다.
 * @example
 * // 권한 안내 페이지에서 사용
 * <RoleGuideLinkButton />
 */
export default function RoleGuideLinkButton() {
  const { t } = useTranslation();
  const rolesGuideURL = getUserGuidePath(GUIDE_PATH.ROLE_GUIDE_PATH);

  return (
    <ExternalLinkButton title={t('layout:service.expection.role_guide')} url={rolesGuideURL} />
  );
}
